import { LanguageType, TaxSourceType } from "@/enums/enums";
import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";
class WithholdingService {
  DoGetTableWhtCertificate(tableWhtCertificateInput: any) {
    const _input = {
      merchantId: MerchantId(),
      data: tableWhtCertificateInput,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/GetTableWhtCertificate", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetTableWhtCertificateAdvanceSearchDefault(tableWhtCertificateInput: any) {
    const _input = {
      merchantId: MerchantId(),
      data: tableWhtCertificateInput,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/GetTableWhtCertificateAdvanceSearchDefault", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetTableWhtCertificateAdvanceSearch(tableWhtCertificateInput: any) {
    const _input = {
      merchantId: MerchantId(),
      data: tableWhtCertificateInput,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/GetTableWhtCertificateAdvanceSearch", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetTableCountWhtCertificate(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/GetTableCountWhtCertificate", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetTableCountWhtCertificateAdvanceSearch(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/GetTableCountWhtCertificateAdvanceSearch", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetWhtCertificateByLastCreateDateTime(contactId: any) {
    const _input = {
      merchantId: MerchantId(),
      data: contactId,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/GetWhtCertificateByLastCreateDateTime", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  QuickInsertWhtCertificate(quickInsertWHTCertificate: any) {
    const _input = {
      merchantId: MerchantId(),
      data: quickInsertWHTCertificate,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/QuickInsertWhtCertificate", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoFetchDataWht(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/FetchDataWhtCertificate", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  InsertWhtCertificate(insertWHTCertificate: any) {
    const _input = {
      merchantId: MerchantId(),
      data: insertWHTCertificate,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/InsertWhtCertificate", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetSuggestNumberWhtModel(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/GetSuggestNumberWhtModel", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetWhtSuggestHeaderByPndType(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/GetWhtSuggestHeaderByPndType", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetDetailWhtCertificate(id: any) {
    const _input = {
      merchantId: MerchantId(),
      data: id,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/GetDetailWhtCertificate", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  VoidWhtCertificate(id: any) {
    const _input = {
      merchantId: MerchantId(),
      data: id,
    };
    return service.peakTaxAPI.post("/api/WhtCertificate/VoidWhtCertificate", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  UpdateWhtCertificate(updateWHTCertificate: any) {
    const _input = {
      merchantId: MerchantId(),
      data: updateWHTCertificate,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/UpdateWhtCertificate", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetFileStorageWhtCertificate(whtId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: whtId,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/GetFileStorageWhtCertificate", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  AddFileStorageWhtCertificate(insertFilesStorage: any) {
    const requestBody: any = [];
    insertFilesStorage.forEach((file: any) => {
      requestBody.push({ merchantId: MerchantId(), data: file });
    });
    return Promise.all(
      requestBody.map((request: any) =>
        service.peakTaxAPI
          .post("/api/WhtCertificate/AddFileStorageWhtCertificate", request, SetHeaderService())
          .then((res) => {
            return res;
          })
      )
    );
  }
  VoidFileStorageWhtCertificate(voidFileStorage: any) {
    const _input = {
      merchantId: MerchantId(),
      data: voidFileStorage,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/VoidFileStorageWhtCertificate", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoSendEmailTransaction(input: any) {
    const _input = {
      merchantId: MerchantId(),
      transactionId: input.transactionId,
      transactionType: input.transactionType,
      sourceType: TaxSourceType.PeakTax,
      financeType: input.financeType,
      emailMessage: {
        toEmail: input.toEmail,
        toBccEmail: input.bccEmail,
        toCcEmail: input.ccEmail,
        linkFile: input.linkFile,
        messageFromSender: input.messageFromSender,
        messageSubject: input.subject,
        sendEmail: input.sendEmail.email,
        selectLanguageTemplateId: input.selectTemplateId,
        contactPerson: input.contactPerson,
        isShowInformationSender: input.isShowInformationSender,
        isShowImageSender: input.isShowImageSender,
      },
    };
    return service.peakRealTimeAPI
      .post("/api/Transaction/SendEmailTransaction", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateDocumentWhtCertificate(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        sourceType: TaxSourceType.PeakTax,
        transactionId: input.transactionId,
        updateVersion: false,
        language: LanguageType.Th,
      }
    };
    return service.peakOnlineView
      .post("/api/WitholdingTax/UpdateWitholdingTaxDetailDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetCommentLogWhtCertificate(whtId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: whtId,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/GetCommentLogWhtCertificate", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  AddCommentLogWhtCertificate(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/AddCommentLogWhtCertificate", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  VoidCommentLogWhtCertificate(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakTaxAPI
      .post("/api/WhtCertificate/VoidCommentLogWhtCertificate", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  GetPeakWhtList(idList: any) {
    const _input = {
      merchantId: MerchantId(),
      data: idList,
    };
    return service.peakTaxAPI.post("/api/WhtCertificate/GetPeakWhtList", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
}

export default new WithholdingService();
